// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__A--7C","title":"styles_title__vH4-W"};